import { dealWizardSearchSchema } from '@/modules/product/deals/deals-search-schemas';
import { DealsRoutePage } from '@/modules/product/deals/deals-route-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/deals/')({
  validateSearch: dealWizardSearchSchema,
  component: DealsRoutePage,
});
